const JSZip = require('jszip')

// adapted from https://gist.github.com/also/900023
// returns Uint8Array of WAV header bytes
function getWavHeader(options) {
  const numFrames =      options.numFrames
  const numChannels =    options.numChannels || 2
  const sampleRate =     options.sampleRate || 44100
  const bytesPerSample = options.isFloat? 4 : 2
  const format =         options.isFloat? 3 : 1

  const blockAlign = numChannels * bytesPerSample
  const byteRate = sampleRate * blockAlign
  const dataSize = numFrames * blockAlign

  const buffer = new ArrayBuffer(44)
  const dv = new DataView(buffer)

  let p = 0

  function writeString(s) {
    for (let i = 0; i < s.length; i++) {
      dv.setUint8(p + i, s.charCodeAt(i))
    }
    p += s.length
  }

  function writeUint32(d) {
    dv.setUint32(p, d, true)
    p += 4
  }

  function writeUint16(d) {
    dv.setUint16(p, d, true)
    p += 2
  }

  writeString('RIFF')              // ChunkID
  writeUint32(dataSize + 36)       // ChunkSize
  writeString('WAVE')              // Format
  writeString('fmt ')              // Subchunk1ID
  writeUint32(16)                  // Subchunk1Size
  writeUint16(format)              // AudioFormat
  writeUint16(numChannels)         // NumChannels
  writeUint32(sampleRate)          // SampleRate
  writeUint32(byteRate)            // ByteRate
  writeUint16(blockAlign)          // BlockAlign
  writeUint16(bytesPerSample * 8)  // BitsPerSample
  writeString('data')              // Subchunk2ID
  writeUint32(dataSize)            // Subchunk2Size

  return new Uint8Array(buffer)
}

// https://stackoverflow.com/questions/62172398/convert-audiobuffer-to-arraybuffer-blob-for-wav-download
// Returns Uint8Array of WAV bytes
function getWavBytes(buffer, options) {
  const type = options.isFloat ? Float32Array : Uint16Array
  const numFrames = buffer.byteLength / type.BYTES_PER_ELEMENT

  const headerBytes = getWavHeader(Object.assign({}, options, { numFrames }))
  const wavBytes = new Uint8Array(headerBytes.length + buffer.byteLength);

  // prepend header, then add pcmBytes
  wavBytes.set(headerBytes, 0)
  wavBytes.set(new Uint8Array(buffer), headerBytes.length)

  return wavBytes
}


module.exports = function getZipFile(state) {
  return new Promise((resolve, reject) => {
    const id = Date.now()
    const pack = new JSZip()
    const ctx = new AudioContext()
    // Put files inside the zip
    state.sampleBoard.forEach(sampleId => {
      const sample = state.samples.find(s => s.id === sampleId)
      const float32 = sample.file.buffer.getChannelData(0)
      const buff = getWavBytes(float32.buffer, {
        isFloat: true,
        numChannels: 1,
        sampleRate: ctx.sampleRate
      })
      pack.file(`${sampleId}.wav`, buff)
    })

    // Generate config file
    const sampleConfig = state.sampleBoard.map((sampleId) => {
      const sample = state.samples.find(s => s.id === sampleId)
      const newSample = Object.assign({}, sample)
      return Object.assign(newSample, { file: `${sampleId}.wav` })
    })
    const config = {
      samples: sampleConfig,
      pack: {
        id: id,
        name: `My Sample Pack`,
        samples: state.sampleBoard.slice()
      }
    }
    pack.file(`config.json`, JSON.stringify(config))

    pack.generateAsync({ type: "blob" })
      .then(function(content) {
        resolve({content, config})
      })
  })
}
